import React, { lazy } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star, Users, BookOpen, Sparkles } from 'lucide-react';
const testimonials = [{
  photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=96&h=96&fit=crop&crop=faces&fm=webp&q=75',
  name: 'María F., Buenos Aires',
  role: '32 años',
  text: 'En 3 días mi panza dejó de estar hinchada todo el tiempo. No lo podía creer. Pensé que era algo que iba a tener que soportar para siempre.'
}, {
  photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=96&h=96&fit=crop&crop=faces&fm=webp&q=75',
  name: 'Laura C., Córdoba',
  role: '28 años',
  text: 'El protocolo del nervio vago cambió mi vida. Ahora tengo una herramienta real para cuando siento que colapso. Ya no dependo de pastillas.'
}, {
  photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=96&h=96&fit=crop&crop=faces&fm=webp&q=75',
  name: 'Sofía P., Rosario',
  role: '41 años',
  text: 'Recuperé mi energía sin tomar café todo el día. Me levanto descansada y llego a la noche sin arrastrarme. Es increíble.'
}];
export function SocialProof() {
  return <section className="py-16 bg-brand-card border-y border-brand-border" data-id="element-325">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-326">
        <FadeIn data-id="element-327">
          <div className="text-center mb-12" data-id="element-328">
            <p className="text-brand-accent font-bold tracking-widest uppercase text-sm mb-2" data-id="element-329">
              Testimonios Reales
            </p>
            <h2 className="text-3xl font-bold" data-id="element-330">
              Lo que dicen las mujeres que ya lo tienen
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-331">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} className="bg-brand-cream border border-brand-border border-l-[3px] border-l-brand-terracotta p-6 rounded-2xl relative" data-id="element-332">
              <div className="flex items-center gap-1 mb-4" data-id="element-333">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand-terracotta text-brand-terracotta" data-id="element-334" />)}
              </div>
              <p className="text-brand-dark mb-6 italic leading-relaxed" data-id="element-335">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-336">
                <img src={t.photo} alt={t.name} loading="lazy" decoding="async" width="48" height="48" className="w-12 h-12 rounded-full object-cover shrink-0 border-2 border-white shadow-sm" data-id="element-337" />
                <div data-id="element-338">
                  <div className="font-bold text-sm" data-id="element-339">{t.name}</div>
                  <div className="text-xs text-brand-muted" data-id="element-340">{t.role}</div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-341">
          <div className="flex flex-wrap justify-center gap-8 md:gap-16 text-center border-t border-brand-border pt-10" data-id="element-342">
            <div data-id="element-343">
              <div className="flex items-center justify-center gap-2 text-3xl font-bold text-brand-dark mb-1" data-id="element-344">
                <Users className="w-6 h-6 text-brand-accent" data-id="element-345" /> +300
              </div>
              <div className="text-sm text-brand-muted" data-id="element-346">mujeres confiaron</div>
            </div>
            <div data-id="element-347">
              <div className="flex items-center justify-center gap-2 text-3xl font-bold text-brand-dark mb-1" data-id="element-348">
                <BookOpen className="w-6 h-6 text-brand-accent" data-id="element-349" /> 3
              </div>
              <div className="text-sm text-brand-muted" data-id="element-350">Tomos completos</div>
            </div>
            <div data-id="element-351">
              <div className="flex items-center justify-center gap-2 text-3xl font-bold text-brand-dark mb-1" data-id="element-352">
                <Sparkles className="w-6 h-6 text-brand-accent" data-id="element-353" /> 72hs
              </div>
              <div className="text-sm text-brand-muted" data-id="element-354">
                Primeros resultados
              </div>
            </div>
            <div data-id="element-355">
              <div className="flex items-center justify-center gap-2 text-3xl font-bold text-brand-dark mb-1" data-id="element-356">
                <Star className="w-6 h-6 text-brand-terracotta fill-brand-terracotta" data-id="element-357" />{' '}
                4.8/5
              </div>
              <div className="text-sm text-brand-muted" data-id="element-358">calificación ⭐</div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}